<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <h2 class="title">Capture Score</h2>
              <div v-if="!event.allowcapturescore">
                <h3>You're not allowed to capture your score at the moment.</h3>
                <router-link :to="{ name: 'Home' }"
                  >Back to My Events</router-link
                >
              </div>
              <ValidationObserver v-else v-slot="{ passes }">
                <div
                  v-if="
                    event && event.config && event.config.capturescorebeforetext
                  "
                  v-html="event.config.capturescorebeforetext"
                  class="has-margin-top-15 has-margin-bottom-15"
                ></div>
                <form @submit.prevent="passes(submit)">
                  <div class="columns" v-if="showDependant">
                    <div class="column">
                      <div class="control">
                        <BaseSelect
                          label="Capture on behalf"
                          v-model="evententry"
                          @input="changeEntry"
                        >
                          <option
                            v-for="entry in evententries"
                            :key="entry._id"
                            :value="entry"
                          >
                            {{
                              entry.dependant
                                ? `${entry.dependant.firstname} ${entry.dependant.surname}`
                                : "Yourself"
                            }}
                          </option>
                        </BaseSelect>
                      </div>
                    </div>
                  </div>
                  <div class="columns is-multiline">
                    <div class="column">
                      <div class="control">
                        <ValidationProvider
                          name="Workout"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Workout"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-select
                              v-model="entry.workout"
                              placeholder="Select Workout"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                              @input="workoutChange"
                            >
                              <option
                                v-for="workout in workouts"
                                :value="workout._id"
                                :key="workout._id"
                              >
                                {{ workout.name }}
                              </option>
                            </b-select>
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div
                    class="columns"
                    v-if="
                      selectedWorkout &&
                      selectedWorkout.content &&
                      selectedWorkout.content !== ''
                    "
                  >
                    <div class="column">
                      <p>
                        <strong>Score Cut-off Time:</strong>
                        {{ selectedWorkout.captureenddate | datetime }}
                      </p>

                      <h2 class="has-text-weight-bold">Workout Description</h2>
                      <div v-html="selectedWorkout.content"></div>
                    </div>
                  </div>
                  <div
                    class="columns is-multiline"
                    v-if="selectedWorkout.format"
                  >
                    <div
                      class="column is-6-desktop"
                      v-if="selectedWorkout.format !== 'time'"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Your Score"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Your Score"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input
                              type="number"
                              v-model.number="entry.score"
                            />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="selectedWorkout.format === 'time'"
                    >
                      <div class="control">
                        <TimeInput
                          label="Your Time"
                          rules="required"
                          v-model="entry.score"
                        />
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="
                        selectedWorkout.tiebreakerformat !== 'time' &&
                        selectedWorkout.tiebreaker
                      "
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Your Tiebreaker Score"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Your Tiebreaker Score"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input
                              type="number"
                              v-model.number="entry.tiebreaker"
                            />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="
                        selectedWorkout.tiebreakerformat === 'time' &&
                        selectedWorkout.tiebreaker
                      "
                    >
                      <div class="control">
                        <TimeInput
                          label="Your Tiebreaker Time"
                          rules="required"
                          v-model="entry.tiebreaker"
                        />
                      </div>
                    </div>
                    <div
                      class="column is-12-desktop"
                      v-if="event._id !== '610107bb7a797a1e44e37fc6'"
                    >
                      <div class="control">
                        <b-checkbox v-model="entry.scaled"
                          >Scaled?
                          <i
                            >(Only check if you haven't done the workout as
                            prescribed for your category)</i
                          ></b-checkbox
                        >
                      </div>
                    </div>
                    <div
                      class="column is-12-desktop"
                      v-if="
                        event._id !== '610107bb7a797a1e44e37fc6' &&
                        event._id !== '61226599d768b8598053cfb9' &&
                        event.config &&
                        !event.config.hidevideolink
                      "
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Video link (Youtube link)"
                          :rules="videolinkrequired ? 'required' : ''"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Video link (Youtube link)"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input
                              v-model="entry.videolink"
                              type="url"
                              :message="errors[0]"
                            />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-12-desktop"
                      v-if="event.config && event.config.showscorecardupload"
                    >
                      <UploadImage
                        label="Upload Scorecard"
                        v-model="entry.scorecardlink"
                        rules="required"
                        folder="scorecards"
                      />
                    </div>
                    <div class="column is-12-desktop">
                      <div class="control">
                        <ValidationProvider
                          name="Additional Info"
                          :rules="notesrequired ? 'required' : ''"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Additional Info"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input
                              v-model="entry.notes"
                              type="textarea"
                              :message="errors[0]"
                            />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="has-text-centered">
                    <div class="is-block has-text-centered">
                      <button
                        class="button btn-align no-lh raised is-medium primary-btn"
                        type="submit"
                        :disabled="saving"
                        :class="{ 'is-loading': saving }"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { addDays } from "date-fns";
import Filters from "@/filters";
import EventEntryApi from "@/api/event-entry";
import LeaderboardApi from "@/api/leaderboard";
import BaseSelect from "@/components/BaseSelect.vue";
import TimeInput from "@/components/TimeInput.vue";
import UploadImage from "@/components/UploadImage.vue";
export default {
  name: "CaptureScore",
  mixins: [Filters],
  data() {
    return {
      loading: true,
      videolinkrequired: true,
      evententry: null,
      evententries: [],
      entry: {},
      saving: false,
    };
  },
  components: {
    TimeInput,
    BaseSelect,
    UploadImage,
  },
  computed: {
    ...mapGetters(["user", "division"]),
    showDependant() {
      return (
        this.evententries.length > 0 &&
        this.evententries.filter((item) => item.dependant).length > 0
      );
    },
    notesrequired() {
      return this.event.config && this.event.config.notesrequired;
    },
    event() {
      if (this.evententries && this.evententries.length > 0) {
        return this.evententries[0].event;
      }
      return {};
    },
    selectedWorkout() {
      if (this.division && this.division.workouts && this.entry.workout) {
        return this.division.workouts.find(
          (workout) => workout._id === this.entry.workout
        );
      }
      return {};
    },
    workouts() {
      if (this.division && this.division.workouts) {
        return this.division.workouts.filter((workout) => {
          if (workout.enablecaptureenddays) {
            return (
              addDays(
                new Date(this.evententry.datecreated),
                workout.captureenddays
              ) > new Date()
            );
          } else {
            return (
              !workout.captureenddate ||
              new Date(workout.captureenddate) > new Date()
            );
          }
        });
      }
      return [];
    },
  },
  async created() {
    const evententries = await EventEntryApi.entriesForEvent(
      this.$route.params.id
    );

    if (this.$route.params.id === "5fbe1a79a73817248ecaa34c") {
      this.evententries = evententries.filter(
        (entry) => entry.paid && entry.entrytype === "Individual"
      );
    } else {
      this.evententries = evententries.filter((entry) => entry.paid);
    }

    if (this.evententries.length > 0 && !this.showDependant) {
      if (this.$route.params.evententry) {
        this.evententry = this.evententries.find(
          (entry) => entry._id === this.$route.params.evententry
        );
      } else {
        this.evententry = this.evententries[0];
      }

      if (
        this.evententry.event &&
        this.evententry.event.config &&
        this.evententry.event.config.videolinknotrequired
      ) {
        this.videolinkrequired = false;
      }
      await this.getDivision({
        event: this.evententry.event._id,
        entrytype: this.evententry.entrytype,
        category: this.evententry.category,
        gender: this.user.gender,
        unfiltered: true,
      });
    }
    this.loading = false;
  },
  methods: {
    ...mapActions(["getDivision"]),
    async changeEntry() {
      if (
        this.evententry.event &&
        this.evententry.event.config &&
        this.evententry.event.config.videolinknotrequired
      ) {
        this.videolinkrequired = false;
      }
      await this.getDivision({
        event: this.evententry.event._id,
        entrytype: this.evententry.entrytype,
        category: this.evententry.category,
        gender: this.user.gender,
        unfiltered: true,
      });
      this.entry = {};
    },
    workoutChange() {
      this.entry.score = null;
      this.entry.tiebreaker = null;
      this.entry.videolinkrequired = null;
    },
    async submit() {
      this.saving = true;
      if (!this.selectedWorkout.tiebreaker) {
        this.entry.tiebreaker = 0;
      }
      try {
        await LeaderboardApi.setScore(
          this.evententry,
          this.entry.score,
          this.entry.tiebreaker,
          this.selectedWorkout,
          this.entry.videolink,
          this.entry.scaled ? this.entry.scaled : false,
          this.entry.notes,
          this.entry.scorecardlink
        );
        this.saving = false;
        this.$buefy.toast.open({
          message: "Your score has been submitted successfully!",
          position: "is-top",
          type: "is-success",
        });
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error saving score!",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>
